import { getCoordinatesByAddress } from '../../../api/nominatium';

// Nominatim(OpenStreetMap) 사용정책상 초당 1건 권장 — 순차 호출 사이에 대기를 둔다.
const GEOCODE_DELAY_MS = 1100;

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

// getCoordinatesByAddress는 성공 시 배열, 실패(catch) 시 단일 객체를 반환하는 기존 함수라 방어적으로 처리한다.
const firstResult = result => (Array.isArray(result) ? result[0] : result);

// rows: parseCorpExcelRows()가 만든 행 배열(address 필드 필요).
// onProgress(done, total)로 진행 상황을 알린다.
export async function geocodeCorpExcelRows(rows, onProgress) {
  const geocoded = [];

  for (let i = 0; i < rows.length; i += 1) {
    const row = rows[i];
    let postalCode = '';
    let city = '';
    let latitude = null;
    let longitude = null;

    if (row.address) {
      try {
        const geo = firstResult(await getCoordinatesByAddress(row.address));
        postalCode = geo?.address?.addressPostCode || '';
        city = geo?.address?.addressCity || '';
        const lat = Number(geo?.coordinate?.latitude);
        const lng = Number(geo?.coordinate?.longitude);
        latitude = Number.isFinite(lat) && lat !== 0 ? lat : null;
        longitude = Number.isFinite(lng) && lng !== 0 ? lng : null;
      } catch {
        // 지오코딩 실패 시 아래 postalCode/city 없음 상태로 남고, 호출부에서 필수값 오류로 표시한다.
      }
    }

    geocoded.push({ ...row, postalCode, city, latitude, longitude });
    onProgress?.(i + 1, rows.length);

    if (i < rows.length - 1) {
      await wait(GEOCODE_DELAY_MS);
    }
  }

  return geocoded;
}
